// // ParallaxItem.js
import { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const ParallaxItem = ({ children, offset = 200 }) => {
  const ref = useRef();

  useEffect(() => {
    const element = ref.current;

    gsap.fromTo(
      element,
        { y: offset },
      {
        y: 0,
        ease: "power2.out",
        scrollTrigger: {
          trigger: element,
         start: "top bottom",
end: "bottom top",
          scrub:1, // Smooth scroll-linked motion
        },
      }
    );

  }, [offset]);

  return <div ref={ref}>{children}</div>;
};

export default ParallaxItem;



